import { Injectable, UnauthorizedException } from '@nestjs/common';
import { ModuleRef } from '@nestjs/core';
import { PassportStrategy } from '@nestjs/passport';
import { Strategy } from 'passport-local';
import { AuthenticationsService } from '../authentications.service';

@Injectable()
export class LocalStrategy extends PassportStrategy(Strategy, 'local') {
  constructor(private moduleRef: ModuleRef, private readonly authService: AuthenticationsService) {
    super({ passReqToCallback: true });
  }

  async validate(req: any, username: string, password: string): Promise<any> {
    // console.log(req, username, password, '----------JJ BOSS ----------')
    const user = await this.authService.validateUser(username, password);
    console.log(user)
    if (!user) {
      throw new UnauthorizedException('Invalid authentication credentials');
    }
    return { ...user };
  }
}

